import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { clearSpaceContentCountsAction, contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { createNoNameCollectionAction } from '~src/spacesPlatform/actions/ContentExplorerCreateActions';
import { showContentTypes, toggleShowWorkbooksAsViews } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../../app/utils/ConnectUtils';
import { selectFlowsOnSiteEnabled } from '../../../../flow/selectors/FlowSelectors';
import { SiteUserSpace, SiteUserSpaceDispatchProps, SiteUserSpaceStateProps } from './SiteUserSpace';

const mapStateToProps: MapStateToProps<SiteUserSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  showWorkbooksAsViews: state.contentExplorer.showWorkbooksAsViews,
  contentCounts: selectContentCounts<'siteuser'>(state, 'siteuser'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isDataAlertsEnabled: SessionSiteSelectors.isDataAlertsEnabled(state),
  isFlowsEnabled: selectFlowsOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<SiteUserSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    filterSelected: showContentTypes,
    fetchUpdatedContentCounts: contentCountsRequest,
    toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
    clearContentCounts: clearSpaceContentCountsAction,
    createNoNameCollection: createNoNameCollectionAction
  },
  dispatch);

export const ConnectedSiteUserSpace = connect(mapStateToProps, mapDispatchToProps)(SiteUserSpace);
